const ScoreParecerInteligenteI18nEsEs = {
  header: {
    title: 'Dictamen inteligente Sankhya Score',
    badgeIa: 'IA',
    badgeBeta: 'Beta',
    subtitle: 'Análisis generado automáticamente a partir de los datos de burós y del ERP.',
    infoTooltip: 'Este análisis es generado por IA y puede contener errores. Antes de tomar cualquier decisión de crédito, revise toda la información. Este dictamen es solo una recomendación.',
    collapseBtn: 'Contraer dictamen',
    expandBtn: 'Expandir dictamen',
  },
  loading: {
    label: 'Generando dictamen inteligente...',
  },
  unavailable: {
    title: 'Dictamen temporalmente no disponible.',
    text: 'Los datos de la consulta están completos y disponibles abajo. Seleccione Actualizar consulta para intentar generar el dictamen nuevamente.',
  },
  partial: {
    title: 'Análisis parcial.',
    text: 'La consulta devolvió pocos indicadores. El dictamen a continuación cubre solo los datos disponibles y puede no reflejar el riesgo completo.',
  },
  risk: {
    label: 'Riesgo evaluado',
    low: 'Riesgo bajo',
    medium: 'Riesgo medio',
    high: 'Riesgo alto',
  },
  confidence: {
    label: 'Confianza del análisis',
    tooltip: 'Alta: datos completos de burós y ERP. Media: datos parciales. Baja: pocos indicadores disponibles.',
    high: 'Alta',
    medium: 'Media',
    low: 'Baja',
  },
  lists: {
    positives: 'Puntos positivos',
    attention: 'Puntos de atención',
    recommendation: 'Recomendación de la IA',
  },
  decision: {
    approve: 'Aprobación recomendada',
    approveWithCaution: 'Aprobación con cautela',
    reject: 'Rechazo recomendado',
  },
  disclaimer: 'Este análisis es generado por IA y puede contener errores. Antes de tomar cualquier decisión de crédito, revise toda la información. Este dictamen es solo una recomendación.',
};

export default ScoreParecerInteligenteI18nEsEs;
